module.exports={
	"Form": "UserRoleJoinViewManifest",
	"Scope": "UserRoleJoin-View",
	"Descriptors":
	{
		"UserRoleJoinDetails.IDUserRoleJoin":
		{
			"Name": "ID",
			"Hash": "URJView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "URJIdentity",
				"Group": "URJIdentity"
			}
		},
		"UserRoleJoinDetails.GUIDUserRoleJoin":
		{
			"Name": "GUID",
			"Hash": "URJView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "URJIdentity",
				"Group": "URJIdentity"
			}
		},
		"UserRoleJoinDetails.IDUser":
		{
			"Name": "User ID",
			"Hash": "URJView-IDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "URJIdentity",
				"Group": "URJIdentity"
			}
		},
		"UserRoleJoinDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "URJView-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "URJIdentity",
				"Group": "URJIdentity"
			}
		},
		"UserRoleJoinDetails.ProxyIDRole":
		{
			"Name": "Proxy Role ID",
			"Hash": "URJView-ProxyIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "URJConfig",
				"Group": "URJConfig"
			}
		},
		"UserRoleJoinDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "URJView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "URJAudit",
				"Group": "URJAudit"
			}
		},
		"UserRoleJoinDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "URJView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "URJAudit",
				"Group": "URJAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Assignment",
			"Hash": "URJIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Assignment",
					"Hash": "URJIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Proxy Configuration",
			"Hash": "URJConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Proxy Configuration",
					"Hash": "URJConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "URJAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "URJAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
